import React, { FC, useMemo } from "react";
import { StatusRendererProps } from "components/Overlay";
import { SIDE } from "_constants";
import { StatusMessage } from "./StatusMessage";
import { getActiveTeamName } from "../utils";
import { FullscreenStatsOverlay } from "./FullscreenStatsOverlay";

export const TennisStatusRenderer: FC<StatusRendererProps> = ({
  message,
  side,
  homeTeam,
  awayTeam,
  activeTeam,
  status,
  normalizedCode,
  Icon,
  description,
  width,
  height,
}) => {
  const resolvedSide: SIDE = useMemo(() => {
    if (typeof side === "string") {
      return String(side).toLowerCase() === "away" ? SIDE.AWAY : SIDE.HOME;
    }
    if (side === SIDE.AWAY || side === SIDE.HOME) return side;
    return SIDE.HOME;
  }, [side]);

  const teamForMessage = useMemo(
    () => activeTeam ?? getActiveTeamName(status),
    [activeTeam, status]
  );

  if (!normalizedCode) return null;

  if (normalizedCode === "1120") {
    return (
      <FullscreenStatsOverlay
        status={status}
        homeTeam={homeTeam}
        awayTeam={awayTeam}
        message={message}
        description={description}
      />
    );
  }

  return (
    <StatusMessage
      title={message}
      normalizedCode={normalizedCode as string}
      team={teamForMessage}
      side={resolvedSide}
      Icon={Icon ?? undefined}
      status={status}
      width={width}
      height={height}
      description={description}
    />
  );
};
